export default __webpack_public_path__ + "static/media/GA_Snappy-2.a49691ef.wav";